import React, { Dispatch, FC, useState } from 'react';
import classes from './configDialog.module.scss';
import { ReactComponent as Pen } from '../../assets/images/userPen.svg';
import { ReactComponent as Delete } from '../../assets/images/delete.svg';
import { ChangeDeleteDialog } from '../Dialogs/ChangeDeleteDialog';
import { ChangeUpdateDialog } from '../Dialogs/ChangeUpdateDialog';
import { Thank } from '../../types/thank';
import Stub from '../../assets/images/stubAvatar.svg';
import { getNoun } from '../../utils/getNoun';

type ThanksItemProps = {
  item: Thank;
  onChangeDelete: Dispatch<number>;
  onChangeUpdate: (id: number, description: string) => Promise<void>;
};

export const ThanksItemSent: FC<ThanksItemProps> = ({
  item,
  onChangeDelete,
  onChangeUpdate,
}) => {
  const [deleteWindow, setDeleteWindow] = useState<boolean>(false);
  const [updateWindow, setUpdateWindow] = useState<boolean>(false);
  const onChangeUpdateWindow = (description: string) => {
    onChangeUpdate(item.id, description).then(() => {
      setUpdateWindow(false);
    });
  };

  const date = item.dateAt;
  const nowDate = new Date();
  const currentDate = Date.parse(nowDate.toString());
  const days = (currentDate - Date.parse(date)) / 86400000;

  return (
    <div className={classes.wrapperItem}>
      <div style={{ paddingBottom: '15px' }} className={classes.wrapper}>
        <p className={classes.day}>
          {Math.round(days) === 0
            ? `сегодня`
            : `${Math.round(days)} ${getNoun(
                Math.round(days),
                'день',
                'дня',
                'дней',
              )} назад`}
        </p>
        <div className={classes.wrapper}>
          <Pen onClick={() => setUpdateWindow(true)} />
          <ChangeUpdateDialog
            value={item.description}
            onChangeUpdate={onChangeUpdateWindow}
            open={updateWindow}
            setOpen={setUpdateWindow}
          />
          <Delete onClick={() => setDeleteWindow(true)} />
          <ChangeDeleteDialog
            button="Удалить"
            title="Удаление Спасибо"
            open={deleteWindow}
            onChangeDelete={() => onChangeDelete(item.id)}
            setOpen={setDeleteWindow}
          />
        </div>
      </div>
      <div className={classes.wrapperThanks}>
        <div className={classes.infoUser}>
          <div className={classes.wrapperBodyValue}>
            <img
              src={`https://radar-app.tmk-group.com/${item.value.icon}`}
              alt={`${item.value.name}`}
            />
            <p className={classes.nameValue}>{item.value.name}</p>
          </div>
          <p className={classes.qualityMarkTo} style={{ fontStyle: 'normal' }}>
            {item.value.valueTypes?.length
              ? `${item.value.valueTypes.map((e) => `${e.description}`)}`
              : ''}
          </p>
          <p className={classes.space} />
          <p className={classes.qualityMarkTo}>— {item.description}</p>
          <div className={classes.wrapperBodyTo}>
            <div className={classes.profileInfoTo}>
              <p className={classes.nameUser}>
                {item.toStaff.lastname} {item.toStaff.firstname}
              </p>
              <p className={classes.lastNameUser}>
                {item.toStaff.org.orgShortName},{' '}
                {item.toStaff.subDivision.subDivisionName}
              </p>
            </div>
            {item.toStaff.avatar ? (
              <img
                className={classes.imageTo}
                src={`https://radar-app.tmk-group.com/${item.toStaff.avatar}`}
                alt={`${item.toStaff.avatar}`}
              />
            ) : (
              <img
                className={classes.imageTo}
                src={`${Stub}`}
                alt={`${item.toStaff.avatar}`}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
